import Browser from '@parameter1/base-cms-marko-web/browser';
import Shared from '@bizbash-media/package-global/browser';

Shared(Browser);

export default Browser;
